import React from "react";
import Banner from "../components/banner/Banner";
import ManetLegacy from "../page_content/home_components/manet_legacy/ManetLegacy";
import Programs from "../page_content/home_components/programs/Programs";
import WhyManet from "../page_content/home_components/why_manet/WhyManet";
import ManetLife from "../page_content/home_components/manet_life/ManetLife";
import LatestNews from "../page_content/home_components/latest_news/LatestNews";
import AlumniSpeak from "../page_content/home_components/alumni_speak/AlumniSpeak";
import PlacedStudents from "../page_content/home_components/placed_students/PlacedStudents";
import TopRecruiters from "../page_content/home_components/top_recruiters/TopRecruiters";
import AdmissionNews from "../page_content/home_components/admission_news/AdmissionNews";

const Home = () => {
  return (
    <div className="home">
      <Banner />
      <AdmissionNews />
      <ManetLegacy />
      <Programs />
      <LatestNews />
      <PlacedStudents />
      <TopRecruiters />
      <WhyManet />
      <ManetLife />
      <AlumniSpeak />
    </div>
  );
};

export default Home;
